import { Swiper, Navigation } from 'swiper'
import { breakpointDown } from '../utils/breakpoints'

Swiper.use([Navigation]);

let sliderCLass = '.posts-slider'
let sliderNextElement = '.posts-slider-next-slide'
let sliderPrevElement = '.posts-slider-prev-slide'

if($('.section-news ' + sliderCLass) && breakpointDown('lg')) {
  let swiper = new Swiper(sliderCLass, {
    slidesPerView: "auto",
    spaceBetween: 12,
    freeMode: true,
    navigation: {
      nextEl: sliderNextElement,
      prevEl: sliderPrevElement,
    }
  });
}
